import React from 'react';

const Flag = ({ countryCodeIso2, ...otherProps }) => {
    return countryCodeIso2 ? (
        <img
            src={`/static/images/flags/${countryCodeIso2.toLowerCase()}.svg`}
            alt={`Flag of ${countryCodeIso2.toUpperCase()}`}
            {...otherProps}
        />
    ) : null;
};

export default Flag;
